/* eslint-disable no-magic-numbers */
import config from 'config';
import { path } from 'routes/path';

// This is a generic request states.
// We are using this for now in the absence of RTK-Query.
export const requestState = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const weChatConn = {
  SUCCESS: 'ConnectionSuccessful',
  CONNECTED: 'WeChat account connected successfully',
};

export const EU_HOSTED = window.location.hostname.startsWith('eu.');

export const Region = {
  US: 'US',
  CA: 'CA',
  EU: 'EU',
};

export const APP_NAME = 'web-react';
export const CURRENT_YEAR = new Date().getFullYear();

export const applicationInbound = 'applicationInbound';

export const phoneLineType = {
  MOBILE: 'mobile',
  LANDLINE: 'landline',
};

export const cacheKey = {
  TOKEN: 'token',
  LL_TOKEN: 'longLivedToken',
  // TODO: `cloudEnvironment` is deprecated; should be replaced -Amir
  CLOUD_ENV: 'cloudEnvironment',
  AUTH0_PREFIX: '@@auth0spajs@@',
  PROVIDERS: 'providers',
  WEB_REACT_IAM: '_iamWR',
  WEB_REACT_SSO: '_ssoWR',
  EXT_SSO: '_ssoP',
  USER_ID: 'userId',
  USER_NAVBAR_PREFS: 'userNavbarPreferences',
  SEND_METHOD: 'sendMethod',
  CANDIDATE_NAME: 'candidateName',
  JOB_NAME: 'jobName',
};
export const subSection = 'subSection';

export const redirectUrls = {
  scheduleMessage: 'scheduleMessage',
  tenDlc: 'tenDlc',
};

export const authTypes = {
  AUTH0: 'AUTH0',
  LEGACY: 'LEGACY',
  SSO: 'LEGACY_SSO',
};

export const sentVia = {
  HUMAN: 'Human',
  AUTO_REPLY: 'AutoReply',
  PLATFORM: 'Platform',
  ARI: 'ARI',
  TEXT: 'Text',
  SEQUENCE: 'Sequence',
};

export const webUrls = {
  FORGOT_PW: `${config.webAppUrl}/#/forgotpw`,
  PRIVACY: 'https://www.textrecruit.com/privacy/',
  TERMS: 'https://www.textrecruit.com/terms-and-conditions/',
  TR_DEMO_REQUEST: 'https://info.textrecruit.com/textrecruit-demo-request',
  HELP_ZENDESK: 'https://textrecruit.zendesk.com/hc/en-us',
  HELP_CENTER: 'https://community.icims.com/login',
};

export const imgUrls = {
  COUNTRY_FLAGS: `${config.imageBaseUrl}/flags`,
  SMALL_LOGO: `${config.imageBaseUrl}/small-logo-text.png`,
  YOU_THUMBNAIL: `${config.imageBaseUrl}/you-64.png`,
  ICIMS_LOGO_OLD: `${config.imageBaseUrl}/product-logos/icims_logo_header_black_teal.svg`,
  ICIMS_LOGO_NEW: `${config.imageBaseUrl}/product-logos/icims_full_color_logo_purple.svg`,
  ICIMS_TEXT_ENGAGEMENT_LOGO_OLD: `${config.imageBaseUrl}/product-logos/icims-text-engagement-logo-color.png`,
  ICIMS_TEXT_ENGAGEMENT_LOGO_NEW: `${config.imageBaseUrl}/product-logos/icims-Text_Engagement.svg`,
  SALESFORCE_LOGO: `${config.imageBaseUrl}/icon-salesforce.png`,
  GOOGLE_LOGO: `${config.imageBaseUrl}/other-logos/logo_google.svg`,
  MICROSOFT_LOGO: `${config.imageBaseUrl}/other-logos/logo_microsoft.svg`,
  MICROSOFT_EXCHANGE_LOGO: `${config.imageBaseUrl}/other-logos/Microsoft_Exchange_logo.svg`,
  FACEBOOK_LOGO: `${config.imageBaseUrl}/other-logos/logo_facebook.svg`,
  BULLHORN_LOGO: `${config.imageBaseUrl}/icon-bullhorn.png`,
  GREENHOUSE_LOGO: `${config.imageBaseUrl}/icon-greenhouse.png`,
  WECHAT_LOGO: `${config.imageBaseUrl}/wechat_logo.png`,
  WECHAT_ICON: `${config.imageBaseUrl}/wechat_icon.svg`,
};

export const calendarOptions = [
  {
    name: 'Google',
    logoLink: imgUrls.GOOGLE_LOGO,
    altText: 'Google',
  },
  {
    name: 'Microsoft',
    logoLink: imgUrls.MICROSOFT_LOGO,
    altText: 'Microsoft',
  },

  {
    name: 'EWS',
    logoLink: imgUrls.MICROSOFT_EXCHANGE_LOGO,
    altText: 'Exchange',
  },
];

// TODO: Do not use these constant as they does not have much context and it will be remove later
export const ZERO = 0;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const FIVE = 5;
export const SIX = 6;
export const SEVEN = 7;
export const EIGHT = 8;
export const NINE = 9;
export const TEN = 10;
export const FIFTEEN = 15;
const SEVENTEEN = 17;
export const TWENTY = 20;
const TWINTY_FIVE = 25;
export const THIRTY = 30;
export const FORTY = 40;
export const FIFTY = 50;
export const SEVENTY_FIVE = 75;
export const NINETY = 90;
export const HUNDRED = 100;
export const FIVE_HUNDERED = 500;
export const THOUSAND = 1000;
export const TWO_THOUSAND = 2000;
export const FIVE_THOUSAND = 5e3;

const MSEC_PER_SEC = 1e3;
const MSEC_PER_MIN = 60e3;
export const SEC_PER_HR = 3600;
export const HRS_PER_DAY = 24;
export const TWO_DAYS_IN_HOURS = 48;
const DAYS_PER_WEEK = 7;

export const ONE_MINUTE = 1;
export const SECONDS_TO_MINUTES = 60;
export const SIXTY_MINUTES = 60;
export const TWENTY_FOUR_HOURS_TO_MINUTES = 1440;
export const REFRESH_TOKEN_INTERVAL = TWINTY_FIVE * MSEC_PER_MIN;
export const IDLE_TIME = THIRTY * MSEC_PER_MIN;
export const MESSAGE_LENGTH = 160;
export const loadTime = HUNDRED;
export const pageLength = 4;
export const maxCandidates = HUNDRED;
export const debounceWait = 800;
export const SEARCH_DELAY = 500;
export const hrsDay = 24;
export const mongoDbIdLength = 24;
export const millisecondsHr = SEC_PER_HR * MSEC_PER_SEC;
export const itemsPerPage = 10;
export const optionsMaxPageNumber = 5;
export const searchTriggerLength = 2;
export const minutesInAnHour = 60;
export const autoHideDuration = 6000;
export const textCount = 1600;
export const successCode = 200;
export const maxFileCharLength = 38;
export const TIME = 'time';
export const LAST_NAME = 'lastName';
export const AVERAGE_CHAT_TIME = 360;
export const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000;
export const productTypes = {
  TEXT_RECRUIT: 'TextRecruit',
  TEXT_REACH: 'TextReach',
  // TODO : add other products
};

export const roles = {
  MANAGER: 'Manager',
  CUSTOMER_ADMIN: 'CustomerAdmin',
  USER: 'User',
  REPORTER: 'Reporter',
  SYSTEM_ADMIN: 'System Admin',
  TEAM_WIDE_USER: 'TeamWideUser',
  CUSTOMER_WIDE_USER: 'CustomerWideUser',
};

export const messageTypes = {
  INBOUND: 0,
  OUTBOUND: 1,
};

export const channelTypes = {
  ALL: 'ALL',
  SMS: 'Sms',
  WHATS_APP: 'WhatsApp',
  FACEBOOK: 'Facebook',
  FACEBOOK_MESSENGER: 'FacebookMessenger',
  JOB_CHAT: 'JobChat',
  WECHAT: 'WeChat',
};

export const appEnv = {
  DEV: 'dev',
  STAGING: 'stg',
  PRODUCTION: 'prd',
};

export const tagTypes = {
  SYSTEM: 'SYSTEM',
  USER: 'USER',
};

export const navigationRoutes = {
  dashboard: path.DASHBOARD,
  teamInbox: `${path.INBOX}/0`,
  myInbox: `${path.INBOX}/1`,
  starred: path.STARRED,
  jobChat: path.JOB_CHAT,
  candidates: path.CANDIDATES,
  campaigns: path.CAMPAIGNS,
  calendar: path.CALENDAR,
  tags: path.TAGS,
  reporting: path.REPORTING,
  downloads: path.DOWNLOADS,
  users: path.USERS,
  teams: path.TEAMS,
};

export const appTypes = {
  SALESFORCE: 'Salesforce',
  BULLHORN: 'Bullhorn',
  EMAIL: 'Email',
  HASAPIENABLED: 'hasApiEnabled',
  GREENHOUSE: 'Greenhouse.io',
  ICIMS: 'iCIMS',
  FACEBOOK: 'Facebook',
  WHATSAPP_SELF_SERVICE: 'WhatsApp',
};

export const sortDirections = {
  ASC: 'asc',
  DESC: 'desc',
};

export const messageOptOutTypes = {
  default: 'icims recommended opt out message',
  custom: 'custom opt out message',
};

export const timeDuration = {
  15: '15 minutes',
  30: '30 minutes',
  45: '45 minutes',
  60: '1 hour',
  90: '1 hour 30 minutes',
  120: '2 hours',
  240: '4 hours',
  480: '8 hours',
  960: '16 hours',
};

export const minDelayDuration = {
  0: 'None',
  1: '1 hour',
  2: '2 hours',
  3: '3 hours',
  4: '4 hours',
  5: '5 hours',
  6: '6 hours',
  7: '7 hours',
  8: '8 hours',
  // @FIXME: we should not be using inconsistent variable naming convention
  // eslint-disable-next-line camelcase
  next_day: 'Next Working Day',
  HRS_PER_DAY: '1 day',
  [TWO * HRS_PER_DAY]: '2 days',
  [THREE * HRS_PER_DAY]: '3 days',
  [FOUR * HRS_PER_DAY]: '4 days',
  [FIVE * HRS_PER_DAY]: '5 days',
  [SIX * HRS_PER_DAY]: '6 days',
  [DAYS_PER_WEEK * HRS_PER_DAY]: '1 week',
  [TWO * DAYS_PER_WEEK * HRS_PER_DAY]: '2 weeks',
};

export const calendarList = {
  googlecal: 'Google',
  microsoftcal: 'Microsoft',
  exchangecal: 'EWS',
  iCims: 'iCIMS',
};

export const calendarTypes = {
  GOOGLE: 'googlecal',
  MICROSOFT: 'microsoftcal',
  EXCHANGE: 'exchangecal',
};

export const availabilityOptions = [
  { label: 'sunday', value: 'SU', fallback: 'Sunday' },
  { label: 'monday', value: 'MO', fallback: 'Monday' },
  { label: 'tuesday', value: 'TU', fallback: 'Tuesday' },
  { label: 'wednesday', value: 'WE', fallback: 'Wednesday' },
  { label: 'thursday', value: 'TH', fallback: 'Thursday' },
  { label: 'friday', value: 'FR', fallback: 'Friday' },
  { label: 'saturday', value: 'SA', fallback: 'Saturday' },
];

const sampleStartDateTime = new Date(new Date().setHours(NINE, ZERO));
const sampleEndDateTime = new Date(new Date().setHours(SEVENTEEN, ZERO));

export const defaultAvailability = [
  { day: 'MO', start: sampleStartDateTime, end: sampleEndDateTime },
  { day: 'TU', start: sampleStartDateTime, end: sampleEndDateTime },
  { day: 'WE', start: sampleStartDateTime, end: sampleEndDateTime },
  { day: 'TH', start: sampleStartDateTime, end: sampleEndDateTime },
  { day: 'FR', start: sampleStartDateTime, end: sampleEndDateTime },
];

const timeZoneConstants = {
  americaAnchorage: 'America/Anchorage',
  americaHalifax: 'America/Halifax',
  americaDenver: 'America/Denver',
  americaChicago: 'America/Chicago',
  americaNewyork: 'America/New_York',
  australiaHobart: 'Australia/Hobart',
  australiaSydney: 'Australia/Sydney',
  australiaBrisbane: 'Australia/Brisbane',
  europeMoscow: 'Europe/Moscow',
  africaMaputo: 'Africa/Maputo',
};

export const extendedTimeZones = [
  { value: 'America/Anchorage', name: 'Anchorage (Alaska)' },
  { value: 'Pacific/Honolulu', name: 'Honolulu (Hawaii)' },
  { value: 'Europe/London', name: 'London (UK)' },
  { value: 'Asia/Manila', name: 'Philippines' },
  { value: 'America/St_Johns', name: 'Newfoundland Time' },
  { value: 'America/Halifax', name: 'Atlantic Time' },
  { value: 'America/Blanc-Sablon', name: 'Atlantic Standard Time' },
  { value: 'Australia/Hobart', name: 'Australia (Tasmania)' },
  { value: 'Australia/Melbourne', name: 'Australia (Melbourne)' },
  { value: 'Australia/Sydney', name: 'Australia (New South Wales)' },
  { value: 'Australia/Brisbane', name: 'Australia (Queensland)' },
  { value: 'Australia/Adelaide', name: 'Australia (Southern)' },
  { value: 'Australia/Darwin', name: 'Australia (Northern)' },
  { value: 'Australia/Perth', name: 'Australia (Western)' },
  { value: 'Europe/Lisbon', name: 'Western European Time' },
  { value: 'Europe/Paris', name: 'Central European Time' },
  { value: 'Europe/Sofia', name: 'Eastern European Time' },
  { value: 'Etc/GMT', name: 'Greenwich Mean Time' },
  { value: timeZoneConstants.europeMoscow, name: 'Moscow Standard Time' },
  { value: 'Africa/Lagos', name: 'Western African Time ' },
  { value: timeZoneConstants.africaMaputo, name: 'Central Aftrican Time' },
  { value: 'Africa/Cairo', name: 'Eastern African Time' },
  { value: timeZoneConstants.africaMaputo, name: 'South Africa Standard Time' },
  {
    value: timeZoneConstants.europeMoscow,
    name: 'Eastern European Standard Time ',
  },
  { value: 'Asia/Riyadh', name: 'Arabian Standard Time' },
  { value: 'Asia/Tehran', name: 'Iran Standard Time' },
  { value: 'Asia/Jerusalem', name: 'Israel Standard Time' },
  { value: 'Asia/Muscat', name: 'Gulf Standard Time' },
];

export const timeZones = [
  { value: 'America/Los_Angeles', name: 'Los Angeles (Pacific)' },
  { value: 'America/Denver', name: 'Denver (Mountain)' },
  { value: 'America/Phoenix', name: 'Phoenix (MST)' },
  { value: 'America/Chicago', name: 'Chicago (Central)' },
  { value: 'America/New_York', name: 'New York (Eastern)' },
];

export const timeZoneMap = {
  'America/New_York': timeZoneConstants.americaNewyork,
  'America/Detroit': timeZoneConstants.americaNewyork,
  'America/Kentucky/Louisville': timeZoneConstants.americaNewyork,
  'America/Kentucky/Monticello': timeZoneConstants.americaNewyork,
  'America/Indiana/Indianapolis': timeZoneConstants.americaNewyork,
  'America/Indiana/Vincennes': timeZoneConstants.americaNewyork,
  'America/Indiana/Winamac': timeZoneConstants.americaNewyork,
  'America/Indiana/Marengo': timeZoneConstants.americaNewyork,
  'America/Indiana/Petersburg': timeZoneConstants.americaNewyork,
  'America/Indiana/Vevay': timeZoneConstants.americaNewyork,
  'America/Toronto': timeZoneConstants.americaNewyork,
  'America/Nipigon': timeZoneConstants.americaNewyork,
  'America/Thunder_Bay': timeZoneConstants.americaNewyork,
  'America/Iqaluit': timeZoneConstants.americaNewyork,
  'America/Pangnirtung': timeZoneConstants.americaNewyork,
  'America/Chicago': timeZoneConstants.americaChicago,
  'America/Indiana/Tell_City': timeZoneConstants.americaChicago,
  'America/Indiana/Knox': timeZoneConstants.americaChicago,
  'America/Menominee': timeZoneConstants.americaChicago,
  'America/North_Dakota/Center': timeZoneConstants.americaChicago,
  'America/North_Dakota/New_Salem': timeZoneConstants.americaChicago,
  'America/North_Dakota/Beulah': timeZoneConstants.americaChicago,
  'America/Denver': timeZoneConstants.americaDenver,
  'America/Boise': timeZoneConstants.americaDenver,
  'America/Phoenix': 'America/Phoenix',
  'America/Los_Angeles': 'America/Los_Angeles',
};

export const extendedTimeZoneMap = {
  'America/Anchorage': timeZoneConstants.americaAnchorage,
  'America/Juneau': timeZoneConstants.americaAnchorage,
  'America/Sitka': timeZoneConstants.americaAnchorage,
  'America/Yakutat': timeZoneConstants.americaAnchorage,
  'America/Nome': timeZoneConstants.americaAnchorage,
  'Pacific/Honolulu': 'Pacific/Honolulu',
  'America/St_Johns': 'America/St_Johns',
  'America/Halifax': timeZoneConstants.americaHalifax,
  'America/Glace_Bay': timeZoneConstants.americaHalifax,
  'America/Moncton': timeZoneConstants.americaHalifax,
  'America/Goose_Bay': timeZoneConstants.americaHalifax,
  'America/Blanc-Sablon': 'America/Blanc-Sablon',
  'Asia/Manila': 'Asia/Manila',
  'Europe/London': 'Europe/London',
  'Australia/Hobart': timeZoneConstants.australiaHobart,
  'Australia/Currie': timeZoneConstants.australiaHobart,
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Sydney': timeZoneConstants.australiaSydney,
  'Australia/Broken_Hill': timeZoneConstants.australiaSydney,
  'Australia/Brisbane': timeZoneConstants.australiaBrisbane,
  'Australia/Lindeman': timeZoneConstants.australiaBrisbane,
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Darwin': 'Australia/Darwin',
  'Australia/Perth': 'Australia/Perth',
  'Europe/Lisbon': 'Europe/Lisbon',
  'Europe/Paris': 'Europe/Paris',
  'Europe/Sofia': 'Europe/Sofia',
  'Europe/Moscow': timeZoneConstants.europeMoscow,
  'Etc/GMT': 'Etc/GMT',
  'Etc/UTC': 'Etc/GMT',
  'Africa/Lagos': 'Africa/Lagos',
  'Africa/Maputo': timeZoneConstants.africaMaputo,
  'Africa/Cairo': 'Africa/Cairo',
  'Asia/Riyadh': 'Asia/Riyadh',
  'Asia/Tehran': 'Asia/Tehran',
  'Asia/Jerusalem': 'Asia/Jerusalem',
  'Asia/Muscat': 'Asia/Muscat',
};

export const timeZonesOnPreferences = [
  { value: 'US/Eastern', name: 'USA: New York, NY (Eastern)' },
  { value: 'US/Central', name: 'USA: Chicago, IL (Central)' },
  { value: 'US/Mountain', name: 'USA: Denver, CO (Mountain)' },
  { value: 'US/Pacific', name: 'USA: San Francisco, CA (Pacific)' },
];

export const inboxType = {
  0: 'team',
  1: 'user',
};

export const inboxAccountName = {
  team: 'Team Inbox',
  user: 'My Inbox',
};

export const inboxId = {
  TEAM: 0,
  USER: 1,
};

export const smsService = {
  TWILIO: {
    provider: 'Twilio',
    link: 'https://www.twilio.com/legal/tos',
  },
  NEXMO: { provider: 'Nexmo', link: 'https://www.nexmo.com/terms-of-use}' },
};

export const messageStatusType = {
  ALL: 'all',
  UNREAD: 'unread',
  SENT: 'sent',
};

export const candidateDetailTabs = {
  MESSAGES: 'messages',
  OVERVIEW: 'overview',
  CAMPAIGNS: 'campaigns',
};

export const rowsPerPageOptions = [FIVE, TEN, TWINTY_FIVE, FIFTY, HUNDRED];

export const campaignTabs = {
  STANDARD: 'NotEquals',
  REENGAGEMENT: 'Equals',
};

export const campaignStatusTypes = {
  ARCHIVED: 'archived',
  OPEN: 'open',
};
export const campaignTypes = {
  STANDARD: 'STANDARD',
  REENGAGEMENT: 'REENGAGEMENT',
};

export const campaignDetailTabs = {
  MESSAGES: 'messages',
  OVERVIEW: 'overview',
  CANDIDATES: 'candidates',
};

export const messageStatus = {
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
  ERROR: 'Error',
  COMPLETE: 'Complete',
  PENDING: 'Pending',
  QUEUED: 'Queued',
};

export const pendoProductAreas = {
  TEXT_ENGAGEMENT: 'Text Engagement',
};

export const tableConstants = {
  DEFAULT_PAGE: ZERO,
  DEFAULT_ROWS_PER_PAGE: TEN,
};

export const candidateStatusTypes = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETED: 'deleted',
  STARRED: 'Starred',
  ARCHIVE: 'archive',
  UNARCHIVE: 'unarchive',
};

export const CandidateSource = {
  ICIMS: 'icims',
  NEXXT: 'nexxt',
  RESTRICTED: '(Restricted)',
};

export const downloadStatus = {
  RETRY: 'retry',
  COMPLETE: 'complete',
};

export const inboxTypeKeys = {
  TEAM: 'team',
  USER: 'user',
};

export const inAccessibleKeys = {
  team: 'teamInbox',
  user: 'myInbox',
  jobChat: 'jobChat',
  events: 'calendar',
  campaigns: 'campaigns',
};

export const totalAccessibleKeys = ['reporting', 'downloads', 'users'];
export const managerAccessibleKeys = ['reporting', 'downloads', 'users'];
export const reporterAccessibleKeys = ['reporting', 'downloads'];

export const AriStatus = {
  AriDisabled: 'AriDisabled',
  AriEnabled: 'AriEnabled',
};

export const pageNum = {
  ZERO: 0,
  ONE: 1,
  FIVE: 5,
  TEN: 10,
  THIRTY: 30,
  HUNDRED: 100,
};

const { origin, pathname } = window.location;
export let PRODUCT_BASE_PATH = `${origin}/web-react`;
const isTextHR = pathname.includes('/hr');
const isTextReach = pathname.includes('/reach');
if (isTextHR) {
  PRODUCT_BASE_PATH = `${origin}/web-react/hr`;
} else if (isTextReach) {
  PRODUCT_BASE_PATH = `${origin}/web-react/reach`;
}

export const CandidateActions = {
  ADD: 'add',
  EDIT: 'edit',
  SCHEDULE_MESSAGE: 'scheduleMessage',
};

export const UserActions = {
  ADD: 'add',
  EDIT: 'edit',
};

export const TeamsActions = {
  ADD: 'add',
  EDIT: 'edit',
};

export const createdColumn = 'created';

export const screenResolution = {
  lg: 1200,
};

export const statusTypes = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  ACTIVE: 'Active',
};

export const customerPlan = {
  FREE: 'Free',
  TRIAL: 'Trial',
  BASIC: 'Basic',
  PRO: 'Professional',
  ENTERPRISE: 'Enterprise',
};

// TODO: To replace the Salesforce link with the actual one as per TXTE-3778.
export const temporaryLink = 'https://icims1--acstest.my.salesforce.com/';

export const defaultCountryCode = 'us';

export const phoneNumberFormat = {
  NATIONAL: 'national',
  INTERNATIONAL: 'international',
};

export const INVALID_DATE = 'Invalid date';

export const userActions = {
  EXPIRE_NOW: 'expireNow',
  ASSIGN_LICENSE: 'assignLicense',
  REMOVE_LICENSE: 'removeLicense',
  DISABLE_USER: 'disableUser',
  ENABLE_USER: 'enableUser',
  DELETE_USER: 'deleteUSer',
  CONVERT_TO_MANAGER: 'convertToManager',
  CONVERT_TO_USER: 'convertToUser',
  CONVERT_TO_REPORTER: 'convertToReporter',
  CONVERT_TO_TEAM_WIDE_USER: 'convertToTeamWideUser',
  OUT_OF_LICENSES: 'outOfLicenses',
  RESET_PASSWORD: 'resetPassword',
  REMOVE_INBOX: 'removeInbox',
  ADD_ATS_ID: 'addAtsId',
  REMOVE_ATS_ID: 'removeAtsId',
};

export const realTimeEvents = {
  CANDIDATE_JOINED: 'candidateJoined',
  AGENT_JOINED: 'agentJoined',
  AGENT_LEFT: 'agentLeft',
};

export const scheduledMessageType = {
  CANDIDATE: 'Candidate',
  CAMPAIGN: 'Campaign',
};

export const messageTimeFrame = {
  NOW: 'now',
  LATER: 'later',
};

export const apiResponse = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const errorMessages = {
  UNKNOWN_USER: 'Unknown User',
};

export const calendarLink = 'http://textr.co/CALENDAR';
export const inbountCandidateApi = 'Inbound Candidate API';
export const iCIMS = 'iCIMS';
export const GREENHOUSE = 'Greenhouse';
export const INTEGRATION = 'INTEGRATION';
export const EMAIL = 'Email';
export const BULLHORN = 'Bullhorn';
export const dripMessageTargetPopulation = {
  UNRESPONSIVE: 'Unresponsive',
  EVERYONE: 'Everyone',
};

export const dlcFormStatus = {
  SUBMITTED: 'SUBMITTED',
  INPROGRESS: 'IN_PROGRESS',
  NOT_INITIATED: 'NOT_INITIATED',
};

export const USER_NAME_LENGTH_LIMIT = 30;
export const FAILED = 'FAILED';
export const FULLNAME = 'fullName';

export const modalModes = {
  ADD: 'Add',
  VIEW: 'View',
  EDIT: 'Edit',
};

export const modalSteps = {
  PROMPT: 'Prompt',
  CONFIRM: 'Confirm',
};

export const calendarConstants = {
  navigate: {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    INITIAL: 'INITIAL',
  },
  views: {
    MONTH: 'month',
    WEEK: 'week',
    DAY: 'day',
    LIST: 'agenda',
  },
};

export const dateCursorDirections = {
  ASCENDING: 'Asc',
  DESCENDING: 'Desc',
};

export const recurrenceEditingOptions = {
  ALL_EVENTS: 'all_events',
  THIS_EVENT: 'one_event',
};

export const recurrenceEditingActions = {
  DELETE: 'Delete',
  EDIT: 'Edit',
};

export const eventTypes = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  VCF: 'VCF',
};

export const reminderTypes = {
  CANDIDATE: 'CANDIDATE',
  RECRUITER: 'RECRUITER',
};

export const frequencies = {
  NON_RECURRING: 'NON_RECURRING',
  YEARLY: 'YEARLY',
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY',
};

export const recurrenceTypes = {
  NON_RECURRING: 'NON_RECURRING',
  GLOBAL_RECURRENCE: 'GLOBAL_RECURRENCE',
  RECURRENCE_INSTANCE: 'RECURRENCE_INSTANCE',
};

export const eventStatuses = {
  ALL: '',
  UPCOMING: 'Upcoming',
  IN_PROGRESS: 'In Progress',
  ENDED: 'Ended',
};

export const reminderDurations = {
  FIFTEEN_MINUTES: 'PT15M',
  ONE_HOUR: 'PT1H',
  TWO_HOURS: 'PT2H',
  ONE_DAY: 'P1D',
  TWO_DAYS: 'P2D',
};

export const participantTypes = {
  USER: 'USER',
  CANDIDATE: 'CANDIDATE',
};

export const itemLimits = {
  USER_TAG_LIMIT: 30,
  CANDIDATE_TAG_LIMIT: 50,
  MAX_PAGE_SIZE: 200,
};

export const componentSize = {
  small: 24,
};

export const messageTemplateType = {
  INTEGRATION: 'INTEGRATION',
  USER: 'USER',
};
export const facebook = {
  FACEBOOK_ACCOUNT_NAME: 'facebookAccountName',
  CONNECTED: 'connected',
};

export const tableHeight = {
  HEIGHT: '319px',
};

export const facebookStep = {
  LOGIN: ZERO,
  ARI_MAPPING: ONE,
  CONNECTION_ERROR: TWO,
  MULTIPLE_PAGES: THREE,
  MANAGE: FOUR,
  DISCONNECT: FIVE,
};

export const phoneValidationStatus = {
  UNCONFIRMED: 'unconfirmed',
  UNDEFINED: 'undefined',
  UNKNOWN: 'unknown',
  CONFIRMED: 'confirmed',
};

export const stockExchangesOption = {
  NYSE: 'NYSE',
};

export const businessTypeOption = {
  EIN: 'EIN',
};

export const dlcErrorStates = {
  brandRegistration: 'brand registration',
};

export const digitalReportStageName = {
  hidden: 'Hidden',
  finished: 'Finished',
  unknown: 'Unknown',
};
export const paginationParams = {
  page: 0,
  rowsPerPage: 5,
};

export const backgroundEventsStatus = {
  PROCESSING: 'Processing',
};

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const digitalReportDateFormatter = {
  YEAR_MONTH_FORMAT_LENGTH: 7,
  YEAR_LAST_SECOND_DIGIT: 2,
};
export const backgroundEventOptions = {
  FIVE: 5,
  FIVE_HUNDERED: 500,
};

export const intervalOption = {
  FIVE: 5,
  FIVE_HUNDERED: 500,
  TWO_THOUSAND: 2000,
  TEN_THOUSAND: 10000,
};

export const tabIndex = {
  ZERO: 0,
  TWO: 2,
};

export const filterAutoCompleteChangeTypes = {
  CLEAR: 'clear',
  INPUT: 'input',
  RESET: 'reset',
};

export const threadsPerPage = 15;

export const whatsAppNumberTypes = {
  LEGACY_TWILIO_WHATSAPP_USER: 'LEGACY_WHATSAPP_NUMBER',
  TWILIO_SMS_WHATSAPP_USER: 'TWILIO_SMS_ENABLED_WHATSAPP_NUMBER',
  NON_TWILIO_PHONE_NUMBER: 'NON_TWILIO_PHONE_NUMBER',
};

export const ariTypes = {
  RECRUITING_ARI: 'RECRUITING_ARI',
  CUSTOMER_SERVICE_ARI: 'CUSTOMER_SERVICE_ARI',
  TECH_SUPPORT_ARI: 'TECH_SUPPORT_ARI',
  CUSTOM_ARI: 'CUSTOM_ARI',
};

// Defining a to avoid magic numbers
export const KB = 1024;
export const MB = KB * KB;
export const fileSizeLimits = {
  // 100Mb
  MAX_FILE_SIZE_LIMIT_MB: HUNDRED * MB,
  // 50Mb
  EACH_FILE_SIZE_LIMIT_MB: FIFTY * MB,
};

export const acceptedFileTypes = [
  '.txt',
  '.md',
  '.html',
  '.doc',
  '.docx',
  '.csv',
  '.xls',
  '.xlsx',
  '.pdf',
];

export const backgroundEventTypes = {
  USER_IMPORT: 'User Import',
  GENERATE_REPORT: 'GenerateReport',
  CANDIDATE_IMPORT: 'Candidate Import',
};
